// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PopoverFooter-base__DAZmU{position:relative;display:flex;flex-direction:column;flex-shrink:0;align-self:stretch}.PopoverFooter-innerContainer__EIZdS{display:flex;gap:var(--size-3);align-items:center;justify-content:space-between;width:var(--size-full);padding:var(--size-3) var(--size-4)}.PopoverFooter-innerContainer__EIZdS>:only-child{flex:1}.PopoverFooter-leftSide__Z_CKh{display:inline-flex;gap:var(--size-2);align-items:center;justify-content:flex-start}.PopoverFooter-rightSide__LlJ8X{display:inline-flex;gap:var(--size-2);align-items:center;justify-content:flex-end}.PopoverFooter-divider__ohKZv{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "PopoverFooter-base__DAZmU",
	"innerContainer": "PopoverFooter-innerContainer__EIZdS",
	"leftSide": "PopoverFooter-leftSide__Z_CKh",
	"rightSide": "PopoverFooter-rightSide__LlJ8X",
	"divider": "PopoverFooter-divider__ohKZv"
};
export default ___CSS_LOADER_EXPORT___;
